import { type ExcessKm, excessKm } from '@rental/domain'

/** The km pricing fixed on the rental at hand-over, as the return sheet carries it. */
interface KmPricedRental {
  kmOut: number
  includedKmPerDay: number | null
  excessKmCents: number | null
}

/**
 * What the return screen shows for km driven past the allowance. Null when the
 * rental has no km pricing: nothing is shown and nothing is charged. The server
 * computes the real charge at return; this is the same sum, for the counter to see.
 */
export function excessKmPreview(
  rental: KmPricedRental,
  kmIn: number | null,
  billableDays: number,
): ExcessKm | null {
  if (rental.includedKmPerDay === null || rental.excessKmCents === null) return null
  return excessKm({
    kmOut: rental.kmOut,
    kmIn: kmIn ?? rental.kmOut,
    includedKmPerDay: rental.includedKmPerDay,
    excessKmCents: rental.excessKmCents,
    billedDays: billableDays,
  })
}
